import SelfProfile from "../../components/SelfProfile/SelfProfile.jsx";

export default function SelfProfilePage() {
    return (
        <SelfProfile/>
    )
};